import { Link } from 'react-router-dom';
import { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import '../css/new.css'; // Custom styles
import logo from '../images/logo1.png';

function FullNavbar() {
  const [expanded, setExpanded] = useState(false);

  const handleNavItemClick = () => {
    setExpanded(false);
  };

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  return (
    <Navbar expand="lg" className="custom-navbar" sticky="top" expanded={expanded}>
      <Container fluid>
        <Navbar.Brand as={Link} to="/" className="brand" onClick={handleNavItemClick}>
          {/* <img src={logo} alt="Hotel Celebration" /> */}

          <span>Majestic
          </span>
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="navbar-nav"
          style={{ color: 'black' }}
          onClick={handleToggle}
        />

        <Navbar.Collapse id="navbar-nav" className="navigate">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/" onClick={handleNavItemClick}>
              Home
            </Nav.Link>
            <Nav.Link as={Link} to="/About" onClick={handleNavItemClick}>
              About
            </Nav.Link>

            <NavDropdown title="Services" id="services-dropdown">
              <NavDropdown.Item as={Link} to="/weddings" onClick={handleNavItemClick}>
                Luxury Room
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/engagements" onClick={handleNavItemClick}>
                Tourist Room
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/receptions" onClick={handleNavItemClick}>
                Party Room 
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/birthdays" onClick={handleNavItemClick}>
                Delux Room
              </NavDropdown.Item>
             
            </NavDropdown>



            <Nav.Link as={Link} to="/gallery" onClick={handleNavItemClick}>
              Gallery
            </Nav.Link>
            <Nav.Link as={Link} to="/contact" onClick={handleNavItemClick}>
              Contact
            </Nav.Link>


            <Nav.Link
          href="https://www.google.com/travel/hotels/Hotel%20Majestic%2C%2046%2F46A%2C%20Doodh%20Mandi%20Road%2C%20Cash%20and%20Pay%20Colony%2C%20Charbagh%2C%20Lucknow%2C%20Uttar%20Pradesh/entity/CgoI9e-Vxf6wsOJ2EAE?ts=CAESCgoCCAMKAggDEAAaIAoCGgASGhIUCgcI6Q8QBhgYEgcI6Q8QBhgZGAEyAhAAKgkKBToDSU5SGgA&utm_campaign=sharing&utm_medium=native&utm_source=htls&shem=hmpsa&sf=car&ved=0CAAQ5JsGahcKEwiY4ZXT84uOAxUAAAAAHQAAAAAQBA"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-success mx-2"
          onClick={() => handleNavItemClick('Hotel Majestic')}
        >
          Book Majestic Hotel
        </Nav.Link>
        <Nav.Link
          href="https://www.google.com/travel/hotels/Megha%20Hotel%2C%20Pan%20Dariba%20Marg%2C%20near%20Khalsa%20Hospital%2C%20Cash%20and%20Pay%20Colony%2C%20Charbagh/entity/CgsI8bWBiMLyyN62ARAB?ts=CAESCgoCCAMKAggDEAAaIAoCGgASGhIUCgcI6Q8QBhgYEgcI6Q8QBhgZGAEyAhAAKgkKBToDSU5SGgA&utm_campaign=sharing&utm_medium=native&utm_source=htls&shem=hmpsa&sf=car&ved=0CAAQ5JsGahcKEwi4y9_c84uOAxUAAAAAHQAAAAAQBA"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-success mx-2"
          onClick={() => handleNavItemClick('Megha Hotel')}
        >
          Book Megha Hotel
        </Nav.Link>




          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default FullNavbar;